import { IEquipment } from '@/pages/Equipment/equipment.types'
import { useState, useRef, useEffect } from 'react'
import useForceUpdate from '@/shared/hooks/useForceUpdate'
import equipmentAtom from '@/pages/Equipment/atoms/equipment.atom'
import { useRecoilValue } from 'recoil'
import useHttpLoader from '@/shared/hooks/useHttpLoader'
import userApi from '../../user.api'

export interface IEquipmentSubscriptionsChanges {
  unsub: Set<IEquipment['id']>
  sub: Set<IEquipment['id']>
}

const useListEquipmentSubscriptionsCtrl = () => {
  const forceRerender = useForceUpdate()
  const { wait, loading } = useHttpLoader()
  const equipmentItems = useRecoilValue(equipmentAtom).items
  const [currentEquipmentSubscriptions, setСurrentEquipmentSubscriptions] = useState<Set<IEquipment['id']>>(new Set())
  const equipmentSubscriptionsChangesRef = useRef<IEquipmentSubscriptionsChanges>({
    unsub: new Set(),
    sub: new Set(),
  })

  useEffect(() => {
    wait(userApi.getEquipmentSubscriptionsList(), (resp) => {
      if (resp.status === 'success') {
        setСurrentEquipmentSubscriptions(new Set(resp.body.equipmentIds))
      }
    })
  }, [])

  const onSubscriptionChange = (v: boolean, name: string) => {
    if (v) {
      equipmentSubscriptionsChangesRef.current.unsub.has(+name)
        ? equipmentSubscriptionsChangesRef.current.unsub.delete(+name)
        : equipmentSubscriptionsChangesRef.current.sub.add(+name)
    } else if (!v) {
      equipmentSubscriptionsChangesRef.current.sub.has(+name)
        ? equipmentSubscriptionsChangesRef.current.sub.delete(+name)
        : equipmentSubscriptionsChangesRef.current.unsub.add(+name)
    }
    forceRerender()
  }

  const handleUnsubscribeAll = () => {
    for (let equipment of equipmentItems) {
      currentEquipmentSubscriptions.has(equipment.id)
        ? equipmentSubscriptionsChangesRef.current.unsub.add(equipment.id)
        : equipmentSubscriptionsChangesRef.current.sub.delete(equipment.id)
    }
    forceRerender()
  }

  const handleSubscribeAll = () => {
    for (let equipment of equipmentItems) {
      !currentEquipmentSubscriptions.has(equipment.id)
        ? equipmentSubscriptionsChangesRef.current.sub.add(equipment.id)
        : equipmentSubscriptionsChangesRef.current.unsub.delete(equipment.id)
    }
    forceRerender()
  }

  const isEquipmentSubscriptionsHaveChanges = () => {
    return (
      equipmentSubscriptionsChangesRef.current.sub.size > 0 || equipmentSubscriptionsChangesRef.current.unsub.size > 0
    )
  }

  return {
    onSubscriptionChange,
    handleUnsubscribeAll,
    handleSubscribeAll,
    isEquipmentSubscriptionsHaveChanges,
    currentEquipmentSubscriptions,
    setСurrentEquipmentSubscriptions,
    equipmentSubscriptionsListLoading: loading,
    equipmentSubscriptionsChangesRef,
  }
}

export default useListEquipmentSubscriptionsCtrl
